import styled from 'styled-components';

export const Main = styled.main`
  max-width: 860px;
  margin: 0 auto;
  padding: 1.2rem 1rem 3rem;
`;

export const Title = styled.h1``;

export const Subtitle = styled.p`
  color: #94a3b8;
`;

export const Form = styled.form`
  background: #111827;
  border: 1px solid rgba(148,163,184,.2);
  border-radius: 12px;
  padding: 1rem;
  display: grid;
  gap: 0.9rem;
`;

export const Field = styled.div``;

export const FieldLabel = styled.label`
  display: block;
  margin-bottom: 0.35rem;
`;

export const FieldInput = styled.input`
  width: 100%;
  background: #0b1222;
  color: ${({ $readonly }) => ($readonly ? '#94a3b8' : '#f8fafc')};
  border: 1px solid #334155;
  border-radius: 8px;
  padding: 0.65rem;
`;

export const Message = styled.p`
  color: ${({ $success }) => ($success ? '#86efac' : '#fca5a5')};
  margin: 0;
`;

export const SubmitButton = styled.button`
  justify-self: start;
  background: #0ea5e9;
  color: #00111a;
  border: 0;
  border-radius: 8px;
  padding: 0.65rem 1rem;
  font-weight: 700;
  cursor: pointer;

  &:disabled {
    opacity: 0.8;
    cursor: wait;
  }
`;
